<template>
 
  <!--新闻动态-->
  <div class="content_box">
    <div class="news_title">
      <div class="news_h3">{{titleName}}</div>
    </div>
    <div class="list_box">
      <template v-if="showList && showList.length > 0">
        <div v-for="(item,index) in showList" :key="index" class="news_list" @click="toDetailPage(item.messageId)">
          <img :src="item.msgUrl" @error="setDefaultImage">
          <div class="list_titlt">{{item.title}}</div>
          <div class="list_date">{{item.createDate}}</div>
        </div>
      </template>
      <template v-else>
          <div class="nothing">
              <img src="../../../assets/img/nothing.png">
              <div class="no_word">暂无内容哦</div>
          </div>
      </template>
    </div>
    <div class="pageself" v-if="showList && showList.length > 0">
      <paginate
        :pageCount="pageCount"
        :containerClass="'pagination'"
        :page-range="3"
        :clickHandler="pageClick"
        :first-last-button="true"
        first-button-text="<<"
        last-button-text=">>"
        :prevText="'上一页'"
        :nextText="'下一页'"
      >
      </paginate>
    </div>
  </div>
       
</template>

<script>
import defaultImage from '../../../assets/img/default_img.png'
export default {
  name: 'ImageTitleListView',
  components:{},
  props: {
    titleName:{
      type:String,
      default:''
    },
    messageList:{
      type:Array,
      default:[]
    },
    perPage:{
      type:Number,
      default:1
    },
    detailRouter:{
      type:String,
      default:''
    },
  },

  data () {
    return {
      
      showList:[],
      totalNum:0,
      pageCount:1,
      
    }
  },
  watch:{
    messageList(val){
        this.messageList = val;
        this.loadData();
    },
  },
  methods:{
    toDetailPage(messageId){
      // this.$router.push({name:'newsDetail', query: {detailId:messageId}});
      // window.open({name:'newsDetail', query: {detailId:messageId}});
      let url = this.$router.resolve({
         name: this.detailRouter,
         query: {detailId:messageId}
       });
       this.$PageUtil.openNewPage(this,url.href)
       
    },
    setDefaultImage(e){
      e.target.src = defaultImage
    },
    pageClick(num){
      this.showList = this.$PageUtil.getStaticPage(num,this.perPage,this.messageList)
    },
    loadData(){
      
      this.totalNum = this.messageList.length;
      this.pageCount = this.$PageUtil.getPageCount(this.totalNum,this.perPage);
      //获得第一页数据
      this.showList = this.$PageUtil.getStaticPage(1,this.perPage,this.messageList);
    },
  },
  mounted(){
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less"> 
    @import '../../../assets/css/ks_foundation.less';
    @import '../../../assets/css/ks_media.less';
    @import '../../../assets/fonts/iconfont.css';
    
</style>
